import { ComponentType, lazy } from 'react';

const LOCAL_STORAGE_PAGE_REFRESH_KEY = 'page-has-been-force-refreshed';

const setItemViolently = (key: string, value: string, retry = true) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    console.error('Failed to set local storage item');
    console.error(error);
    if (retry) {
      console.log('Clearing localStorage cache and setting item again.');
      window.localStorage.clear();
      setItemViolently(key, value, false);
    }
  }
};

// Code taken here : https://raphael-leger.medium.com/react-webpack-chunkloaderror-loading-chunk-x-failed-ac385bd110e0
export const lazyWithRetry = <T extends ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>,
) =>
  // @ts-ignore We don't want to either throw or return the component when page is reloaded
  lazy(async () => {
    try {
      const component = await componentImport();

      window.localStorage.setItem(LOCAL_STORAGE_PAGE_REFRESH_KEY, 'false');

      return component;
    } catch (error) {
      console.error('Failed to lazy-load a component');
      console.error(error);

      const pageHasAlreadyBeenForceRefreshed = JSON.parse(
        window.localStorage.getItem(LOCAL_STORAGE_PAGE_REFRESH_KEY) || 'false',
      );

      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        console.log('Preparing to reload the page');
        // If we hit a localStorage issue while setting flags, we clear the cache entirely
        setItemViolently(LOCAL_STORAGE_PAGE_REFRESH_KEY, 'true');
        console.log('Reloading page to refresh cache and avoid chunk error');
        window.location.reload();
      } else {
        // The page has already been reloaded
        // Assuming that user is already using the latest version of the application.
        // Let's let the application crash and raise the error.
        console.log('Failed to load component after a force-reload (-> possible dependency bug)');
        throw error;
      }
    }
  });
